import React, { useCallback, useEffect, useState, useMemo } from 'react'
import ModuleHeading from '../../component/ModuleHeading'
import { Avatar, Box, Card, CardContent, Divider, List, ListItem, Paper, TextField, Typography, Select, MenuItem, Chip, Skeleton } from '@mui/material'
import { StyledBlueButton, StyledCancelButton, Textarea } from '../../component/StyledComponent'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import { useCommon } from '../../context/CommonContext';
import { baseUrl, get, post, patch } from '../../services/api-services';
import TemplateDialog from '../../component/Support/AddTemplete';
import SendIcon from "@mui/icons-material/Send";
import debounce from 'lodash/debounce';
import { useLocation } from "react-router-dom";
import { convertToCustomFormat } from '../../modules/ConvertDate';
import Badge from '@mui/material/Badge';

const SupportSkeleton = () => {
    return (
        <CardContent>
            <Box className="flex items-center space-x-2">
                <Skeleton variant="circular" width={44} height={44} />
                <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="90%" />
                    <Skeleton variant="text" width="40%" />
                </Box>
                <Box sx={{ textAlign: "right", width: "50px" }}>
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="rounded" width="100%" height={18} sx={{ mt: 1 }} />
                </Box>
            </Box>
        </CardContent>
    )
}

export default function Support() {
    const [newMessage, setNewMessage] = useState("");
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        const updateMaxHeight = () => {
            const height = window.innerHeight - 100;
            setMaxHeight(height);
        };
        updateMaxHeight();
        window.addEventListener('resize', updateMaxHeight);
        return () => window.removeEventListener('resize', updateMaxHeight);
    }, []);
    const [searchSupport, setSearchSupport] = useState("");
    const [searchCustomer, setSearchCustomer] = useState("");
    const [newMsg, setNewMsg] = useState(false);
    const [loadingSupport, setLoadingSupport] = useState(true);
    const [loadingCustomers, setLoadingCustomers] = useState(true);
    const [supportTopics, setSupportTopics] = useState([]);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const { currentUser, setSnackbar } = useCommon();
    const [allCustomers, setAllCustomers] = useState([]);
    const [createMsgMode, setCreateMsgMode] = useState(false);
    const [createMsg, setCreateMsg] = useState({ topic: "", msg: "" });
    const [template, setTemplate] = useState({ name: "", msg: "" });
    const [errors, setErrors] = useState({ topic: false, message: false, customer: false });
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const location = useLocation();
    const { id, cId, returnTo } = location.state || {};
    // const handleSearchChange = (e) => {
    //     if (newMsg) { setSearchCustomer(e.target.value); }
    //     else { setSearchSupport(e.target.value); }
    // };
    const fetchSupportTopics = useCallback(async (searchSupport) => {
        const filter = {
            order: 'lastCustomerMsgOn DESC',
            include: [
                { relation: 'chats', scope: { order: 'createdAt ASC' } },
                { relation: 'customer' }
            ],
        };
        const encodedFilter = encodeURIComponent(JSON.stringify(filter));
        let url = `/SupportTopics?filter=${encodedFilter}`;

        try {
            const response = await get(url);
            let data = response.data || [];
            
            data.forEach((topic) => {
                let unreadMsg = 0;
                if (topic.chats) {
                    topic.chats.forEach((chat) => {
                        if (chat.status === 'unread' && chat.sendBy === 'customer') {
                            unreadMsg++;
                        }
                    });
                }
                topic.unreadMsg = unreadMsg;

                topic.lastCustomerMsgOn = new Date(topic.lastCustomerMsgOn).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                });
            });

            // Client side search filtering across customer name and topic subject
            if (searchSupport && searchSupport.trim()) {
                const query = searchSupport.toLowerCase().trim();
                data = data.filter(topic => 
                    (topic.customer && topic.customer.name && topic.customer.name.toLowerCase().includes(query)) ||
                    (topic.topic && topic.topic.toLowerCase().includes(query))
                );
            }

            setSupportTopics(data);
        } catch (error) {
            setSnackbar({
                openSnackbar: true,
                message: `${error}`,
                severity: 'error'
            })
        } finally {
            setLoadingSupport(false);
        }
    }, [setSnackbar]);
    const onGetAllCustomer = useCallback(async (searchCustomer) => {
        const filter = {
            where: { role: "user" },
            order: "createdAt DESC",
        };

        // Add search condition only if searchTerm is not empty
        if (searchCustomer) {
            filter.where.name = { like: searchCustomer, options: "i" };
        }

        setLoadingCustomers(true);
        try {
            // Construct query string
            const queryParams = new URLSearchParams({ filter: JSON.stringify(filter) });
            const res = await get(`/Customers?${queryParams}`);
            if (res?.statusCode === 200) {
                setAllCustomers(res?.data);
                if (cId) {
                    const selectedCustomer = res?.data?.find((item) => item.id === cId);
                    if (selectedCustomer) {
                        setSelectedCustomer(selectedCustomer);

                        setCreateMsgMode(true);
                        setNewMsg(true);
                    }
                }

            }
        } catch (error) {
            console.error("Error fetching customers:", error);
            throw error;
        } finally {
            setLoadingCustomers(false);
        }
    }, [cId]);

    const handleDialogClose = () => { setOpenDialog(false); setTemplate({ name: "", msg: "" }) }
    const handleTemplateButton = () => setOpenDialog(true);


    const handleCreateMessage = async () => {
        const topicVal = (createMsg?.topic || "").trim();
        const msgVal = (newMessage || "").trim();
        const customerId = selectedCustomer?.id;

        const newErrors = {
            topic: !topicVal,
            message: !msgVal,
            customer: !customerId
        };

        if (newErrors.topic || newErrors.message || newErrors.customer) {
            setErrors(newErrors);
            if (newErrors.customer) {
                setSnackbar({
                    openSnackbar: true,
                    message: "Please select a customer from the list first.",
                    severity: "error"
                });
            } else {
                setSnackbar({
                    openSnackbar: true,
                    message: "Subject and Message cannot be empty.",
                    severity: "error"
                });
            }
            return;
        }

        setErrors({ topic: false, message: false, customer: false });

        const res = await post('/SupportTopics',
            {
                "topic": topicVal,
                "createdAt": new Date(),
                "updatedAt": new Date(),
                "adminReply": true,
                "lastCustomerMsgOn": new Date(),
                "customerId": customerId,
                "sendBy": "admin",
                "status": "unread",
                "adminId": currentUser?.userId
            }
        )
        if (res?.statusCode === 200) {
            setSelectedTopic(res?.data);
            setCreateMsgMode(false);
            setNewMsg(false);
            setCreateMsg({ topic: "", msg: "" });
            handleSendMessage(res?.data?.id);
        }
    }
    const handleSendMessage = async (idOrEvent) => {
        let id = (idOrEvent && typeof idOrEvent === 'string') ? idOrEvent : null;
        if (idOrEvent && idOrEvent.preventDefault) idOrEvent.preventDefault();
        if (!newMessage) {
            setSnackbar({ openSnackbar: true, message: "Please write a message", severity: 'warning' });
        }
        if (!selectedTopic && !id) {
            setSnackbar({ openSnackbar: true, message: "Please select a support topic", severity: 'warning' });
            return;
        }
        let chatData = {
            "message": newMessage,
            "createdAt": new Date(),
            "sendBy": "admin",
            "status": "unread",
            "supportTopicId": newMsg ? id : selectedTopic.id,
            "adminId": currentUser?.userId
        };
        let body = chatData;
        try {
            await post(`/Chats`, body);
            // Update topic to show admin has replied and update timestamp
            await patch(`/SupportTopics/${newMsg ? id : selectedTopic.id}`, { 
                adminReply: true,
                updatedAt: new Date(),
                // If status was PENDING, maybe move it to IN PROGRESS? 
                // Let's keep it as is or set to IN PROGRESS if it was PENDING
                status: (selectedTopic?.status === 'PENDING' || !selectedTopic?.status) ? 'IN PROGRESS' : selectedTopic?.status
            });
            setNewMessage("");
            supportDelay(searchSupport);
            delay(5000)

            let topic = selectedTopic ? selectedTopic : { id: id }

            onSetTopic(topic)
            // Optionally, refresh the topic data or update the UI
        } catch (error) {
            console.error("Error sending message", error);
            setSnackbar({ openSnackbar: true, message: "Failed to send message", severity: 'warning' });
        }
    };
    const onSetTopic = useCallback(async (topic) => {
        const getChat = await get(`/SupportTopics/${topic?.id}?filter={"include" : ["chats","customer"]}`);
        setSelectedTopic(getChat?.data);

        // Mark customer messages as read when admin opens the topic
        const unreadCustomerChats = getChat?.data?.chats?.filter(c => c.status === 'unread' && c.sendBy === 'customer');
        if (unreadCustomerChats?.length > 0) {
            try {
                // Update all unread messages for this topic from customer
                await post(`/Chats/update?where={"supportTopicId":"${topic.id}","sendBy":"customer"}`, { status: 'read' });
                // Refresh topics to update unread badges
                fetchSupportTopics(searchSupport);
            } catch (error) {
                console.error("Error marking messages as read:", error);
            }
        }
    }, [fetchSupportTopics, searchSupport]);

    const handleStatusChange = async (newStatus) => {
        try {
            const res = await patch(`/SupportTopics/${selectedTopic.id}`, { status: newStatus });
            if (res.statusCode === 200) {
                setSnackbar({
                    openSnackbar: true,
                    message: 'Status updated successfully',
                    severity: 'success'
                });
                onSetTopic(selectedTopic);
                fetchSupportTopics(searchSupport);
            }
        } catch (error) {
            console.error("Error updating status:", error);
            setSnackbar({
                openSnackbar: true,
                message: 'Failed to update status',
                severity: 'error'
            });
        }
    };
    const supportDelay = useMemo(() => debounce((search) => fetchSupportTopics(search), 300), [fetchSupportTopics]);
    const customerDelay = useMemo(() => debounce((search) => onGetAllCustomer(search), 300), [onGetAllCustomer]);
    useEffect(() => {
        customerDelay(searchCustomer);
    }, [searchCustomer, customerDelay])
    useEffect(() => {
        supportDelay(searchSupport);
    }, [searchSupport, supportDelay]);
    useEffect(() => {
        if (id) { onSetTopic({ id: id }) }
    }, [id, onSetTopic]);
    return (
        <div className="flex flex-col flex-1">
            <ModuleHeading title="Support" navigateTo={returnTo || "/admin/dashboard"} />
            <Paper className="flex flex-col flex-1 md:flex-row h-full" sx={{ maxHeight: maxHeight, overflow: 'hidden' }}>
                <Box className="flex flex-col relative w-full md:w-[35%] h-full overflow-hidden">
                    <Box sx={{ position: "sticky", top: 0, zIndex: 2, bgcolor: "background.paper" }}>
                        <CardContent>
                            <div className="flex justify-end">
                                 <StyledCancelButton variant="outlined"
                                     onClick={() => {
                                         setNewMsg(!newMsg);
                                         setErrors({ topic: false, message: false, customer: false });
                                     }}
                                     color="primary" endIcon={newMsg ? <CloseIcon /> : <AddIcon />} >
                                     {newMsg ? "BACK" : "NEW MESSAGE"}
                                 </StyledCancelButton>
                            </div>
                            <TextField
                                variant="standard"
                                label="Search"
                                onChange={(e) => { newMsg ? setSearchCustomer(e.target.value) : setSearchSupport(e.target.value); }}
                                value={newMsg ? searchCustomer : searchSupport}
                                fullWidth
                            />

                        </CardContent>
                    </Box>
                    <Box sx={{ overflowY: "auto", overflowX: "hidden", borderRight: "1px solid #e0e0e0", flexGrow: 1, minHeight: 0 }}>
                        {newMsg ?
                            <List>
                                {loadingCustomers ? (
                                    Array.from({ length: 6 }).map((_, i) => (
                                        <React.Fragment key={i}>
                                            <ListItem sx={{ display: "flex", alignItems: "center", p: 2 }}>
                                                <Skeleton variant="circular" width={44} height={44} sx={{ mr: 2 }} />
                                                <Skeleton variant="text" width="70%" height={24} />
                                            </ListItem>
                                            <Divider />
                                        </React.Fragment>
                                    ))
                                ) : allCustomers?.map((c) => (
                                    <React.Fragment key={c.id}>
                                        <ListItem
                                            onClick={() => { setSelectedCustomer(c); setCreateMsgMode(true) }}
                                            sx={{ display: "flex", alignItems: "flex-start", p: 2, cursor: "pointer", bgcolor: selectedCustomer?.id === c.id ? 'action.selected' : 'transparent' }}
                                        >
                                            <Avatar
                                                //src="/assets/userProfile.png"
                                                src={c?.image ? `${baseUrl}/Uploads/profile-pic/download/${c?.image}` : "/assets/userProfile.png"}
                                                alt="Customer"
                                                sx={{ width: 44, height: 44, mr: 2 }}
                                            />
                                            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                                {c?.name || "Unknown Customer"}
                                            </Typography>

                                        </ListItem>
                                    </React.Fragment>
                                ))}
                            </List>
                            :
                             <List sx={{ height: '100%' }}>
                                {loadingSupport ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <SupportSkeleton key={index} /> 
                                        ))}
                                    </>
                                ) : supportTopics && supportTopics.length > 0 ? (
                                    supportTopics.map((topic) => (
                                        <React.Fragment key={topic.id}>
                                            <ListItem
                                                onClick={() => onSetTopic(topic)}
                                                sx={{ display: "flex", alignItems: "flex-start", p: 2, cursor: "pointer", bgcolor: selectedTopic?.id === topic.id ? 'action.selected' : 'transparent' }}
                                            >
                                                <Avatar
                                                    src={topic?.customer?.image ? `${baseUrl}/Uploads/profile-pic/download/${topic?.customer?.image}` : "/assets/userProfile.png"}
                                                    alt={topic?.customer?.name || "Customer"}
                                                    sx={{ width: 44, height: 44, mr: 2 }}
                                                />
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                                        {topic.customer?.name || "Unknown Customer"}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {/* {topic.topic} */}
                                                        {(() => {
                                                            const message = topic.topic;
                                                            const words = message ? message.split(" ") : [];
                                                            return words.length > 3
                                                                ? words.slice(0, 3).join(" ") + "..."
                                                                : message || "";
                                                        })()}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                                        {(() => {
                                                            const message = topic.chats && topic.chats[0]?.message || "No messages yet";
                                                            const words = message.split(" ");
                                                            return words.length > 5
                                                                ? words.slice(0, 5).join(" ") + "..."
                                                                : message;
                                                        })()}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        textAlign: "right",
                                                        minWidth: "85px",
                                                    }}
                                                >
                                                    <Typography variant="caption" color="textSecondary">
                                                        {topic.lastCustomerMsgOn}
                                                    </Typography>
                                                    <br />
                                                    <Chip 
                                                        label={topic.status === 'unread' ? 'PENDING' : (topic.status || 'PENDING')} 
                                                        size="small"
                                                        sx={{ 
                                                            fontSize: '0.65rem', 
                                                            height: '20px', 
                                                            textTransform: 'uppercase',
                                                            backgroundColor: 
                                                                topic.status === 'RESOLVED' ? 'rgba(76, 175, 80, 0.1)' : 
                                                                topic.status === 'IN PROGRESS' ? 'rgba(33, 150, 243, 0.1)' : 
                                                                'rgba(255, 152, 0, 0.1)',
                                                            color: 
                                                                topic.status === 'RESOLVED' ? '#4caf50' : 
                                                                topic.status === 'IN PROGRESS' ? '#2196f3' : 
                                                                '#ff9800',
                                                            fontWeight: 'bold',
                                                            mt: 0.5
                                                        }} 
                                                    />
                                                    <br />
                                                    {topic.unreadMsg > 0 && (
                                                        <Typography variant="caption" color="error">
                                                            <Badge color="primary" badgeContent={topic.unreadMsg}
                                                                sx={{
                                                                    borderRadius: '0px !important',
                                                                    '& .MuiBadge-badge': {
                                                                        color: "#fff",
                                                                        width: '30px',
                                                                        marginRight: 2
                                                                    },
                                                                }}
                                                            />
                                                            {/* Unread */}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </ListItem>
                                            <Divider />
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, px: 2, textAlign: 'center' }}>
                                        <Typography variant="body2" sx={{ color: '#888', fontSize: '0.85rem' }}>
                                            No conversations found
                                        </Typography>
                                    </Box>
                                )}
                            </List>

                        }
                    </Box>
                </Box>
                {/* Right Section: Chat Messages */}
                {newMsg ?
                    <Box className="flex flex-col w-full md:w-[65%] h-full overflow-hidden">
                        {createMsgMode ? (
                            <Card sx={{ flexGrow: 1, display: "flex", flexDirection: "column", margin: 2, padding: 2, overflow: "hidden", minHeight: 0 }}>
                                <CardContent sx={{ flexGrow: 1, overflowY: "auto", display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="h6" fontWeight="bold" display="flex">
                                        <Avatar
                                            src="assets/userProfile.png"
                                            alt={selectedCustomer?.name || "Customer"}
                                            sx={{ width: 44, height: 44, mr: 2 }}
                                        /> {selectedCustomer?.name || "Customer"}
                                    </Typography>
                                </CardContent>
                                <Box className="flex flex-col gap-2 p-2">
                                    <TextField 
                                        size="small" 
                                        placeholder='Write Subject' 
                                        value={createMsg?.topic || ""}
                                        onChange={(e) => {
                                            setCreateMsg((prev) => ({ ...prev, topic: e.target.value }));
                                            if (errors.topic) setErrors(prev => ({ ...prev, topic: false }));
                                        }}
                                        error={errors.topic}
                                        helperText={errors.topic ? "Subject is required" : ""}
                                    />
                                    <Textarea 
                                        rows="4" 
                                        fullWidth 
                                        placeholder="Write Message Here" 
                                        className={`p-2 rounded-md border ${errors.message ? 'border-red-500' : 'border-gray-300'}`}
                                        value={newMessage}
                                        onChange={(e) => {
                                            setNewMessage(e.target.value);
                                            if (errors.message) setErrors(prev => ({ ...prev, message: false }));
                                        }}
                                    />
                                    {errors.message && (
                                        <Typography variant="caption" color="error" sx={{ mt: -0.5, ml: 1 }}>
                                            Message is required
                                        </Typography>
                                    )}
                                    <Box className="flex justify-between gap-2">
                                        <StyledCancelButton type="button" variant="outlined" onClick={handleTemplateButton} sx={{ textTransform: "none", marginRight: 1 }} endIcon={<AddIcon />}>TEMPLATE</StyledCancelButton>
                                        <StyledBlueButton
                                            type="button"
                                            endIcon={<SendIcon />} 
                                            onClick={handleCreateMessage}
                                        >
                                            SEND
                                        </StyledBlueButton>
                                    </Box>
                                </Box>
                            </Card>
                        ) : (
                            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Typography variant="body1" color="textSecondary">Select user to send message</Typography>
                            </Box>
                        )}
                    </Box>
                    : <Box className="flex flex-col w-full md:w-[65%] h-full overflow-hidden">
                        {selectedTopic ? (
                            <Card sx={{ flexGrow: 1, display: "flex", flexDirection: "column", margin: 2, padding: 2, overflow: "hidden", minHeight: 0 }}>
                                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    <Typography variant="h6" fontWeight="bold" display="flex">
                                        <Avatar
                                            src={`${baseUrl}/Uploads/profile-pic/download/${selectedTopic.customer?.image}` || "/assets/userProfile.png"}
                                            alt={selectedTopic.customer?.name || "Customer"}
                                            sx={{ width: 44, height: 44, mr: 2 }}
                                        /> {selectedTopic.customer?.name || "Customer"}
                                        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 'bold', textTransform: 'uppercase' }}>Status:</Typography>
                                            <Select
                                                value={selectedTopic.status === 'unread' ? 'PENDING' : (selectedTopic.status || 'PENDING')}
                                                onChange={(e) => handleStatusChange(e.target.value)}
                                                size="small"
                                                variant="standard"
                                                sx={{ 
                                                    fontSize: '0.75rem', 
                                                    color: 
                                                        selectedTopic.status === 'RESOLVED' ? '#4caf50' : 
                                                        selectedTopic.status === 'IN PROGRESS' ? '#2196f3' : 
                                                        '#ff9800',
                                                    '&:before, &:after': { border: 'none' },
                                                    '& .MuiSelect-select': { py: 0.5, px: 1, fontWeight: 'bold' }
                                                }}
                                            >
                                                <MenuItem value="PENDING">PENDING</MenuItem>
                                                <MenuItem value="IN PROGRESS">IN PROGRESS</MenuItem>
                                                <MenuItem value="RESOLVED">RESOLVED</MenuItem>
                                            </Select>
                                        </Box>
                                    </Typography>
                                    <Typography variant="h6" className='flex justify-center bg-[#e8eaf6]' padding={1} margin={1}>
                                        <span className='text-[#3c50b4] font-medium text-sm'>SUBJECT :  {selectedTopic?.topic || "Customer"} </span>
                                    </Typography>
                                    <div className='flex-1 overflow-y-auto'>
                                        {selectedTopic?.chats?.map((chat, index) => (
                                            <Box key={index} sx={{ display: "flex", justifyContent: chat.sendBy === "customer" ? "flex-start" : "flex-end", marginBottom: 2 }}>
                                                <Box sx={{ maxWidth: "70%", padding: 2, borderRadius: 2 }}>
                                                    <Box display="flex" alignItems="center">
                                                        <Box className="w-full flex flex-col">
                                                            <Typography minHeight={10} marginBottom={1} borderRadius={2} backgroundColor={(theme) => theme.palette.messageBoxBg} padding={1}>
                                                                {chat.message}
                                                            </Typography>
                                                            <Box display='flex' alignItems='center' justifyContent="space-between" gap={5}>
                                                                <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                                                                    {convertToCustomFormat(chat?.createdAt)}
                                                                </Typography>
                                                                <Avatar
                                                                    src={`${baseUrl}/Uploads/profile-pic/download/${currentUser?.profile}` || "assets/userProfile.png"}
                                                                    alt={currentUser?.userName}
                                                                    sx={{ width: 44, height: 44 }}
                                                                />

                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}
                                    </div>
                                </CardContent>
                                <Box className="flex flex-col gap-2 p-2">
                                    <Textarea rows="4" fullWidth placeholder="Write Message Here" className='p-2 rounded-md'
                                        value={newMessage}
                                        onChange={(e) => setNewMessage(e.target.value)}
                                    />
                                    <Box className="flex justify-between gap-2">
                                        <StyledCancelButton type="button" variant="outlined" onClick={handleTemplateButton} sx={{ textTransform: "none", marginRight: 1 }} endIcon={<AddIcon />}>TEMPLATE</StyledCancelButton>
                                        <StyledBlueButton type="button" disabled={!newMessage} endIcon={<SendIcon />} onClick={handleSendMessage}>SEND</StyledBlueButton>
                                    </Box>
                                </Box>
                            </Card>
                        ) : (
                            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Typography variant="body1" color="textSecondary">Select a topic to view messages</Typography>
                            </Box>
                        )}
                    </Box>}
            </Paper>
            <TemplateDialog 
                open={openDialog} 
                setOpen={setOpenDialog} 
                onClose={handleDialogClose} 
                template={template} 
                setTemplate={setTemplate} 
                onTemplateSelect={(selectedMsg) => setNewMessage((prev) => prev ? `${prev}\n${selectedMsg}` : selectedMsg)}
            />
        </div>
    )
}
